import { Controller } from 'stimulus'
import i18nSetup from "../i18n-setup"

export default class AvatarUploadController extends Controller {
  static targets = [ 'input', 'image', 'message']

  initialize() {
    this.i18n = i18nSetup()
  }

  upload() {
    const image = this.imageTarget;
    const file = this.inputTarget.files[0];
    const fileNameTest = /\.(jpe?g|png|gif)$/i.test(file.name);
    const fileSizeTest = file.size <= 1048576;

    if (fileNameTest && fileSizeTest) {
      var reader  = new FileReader();

      $(this.messageTarget).hide();

      reader.onload = function(e) {
        $(image).attr('src', e.target.result);
      }

      reader.readAsDataURL(file);
    } else {
      this.showError(fileNameTest, fileSizeTest);
    }
  }

  showError(fileNameTest, fileSizeTest) {
    let message = "";

    if (fileNameTest === false) {
      message = this.i18n.t('web.javascript.image.type')
    }
    else if (fileSizeTest === false) {
      message = this.i18n.t('web.javascript.image.size', { min: '0 bytes', max: '1 MB' })
    }

    $(this.messageTarget).text(message)
    $(this.messageTarget).show();
  }

}
